var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_ProfitShareReset"),
        width: "900px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "custom-class": "details-view profit-share-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.initShareAmount,
                "label-width": "90px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "el-form-item-wrapper",
                  staticStyle: { "padding-top": "5px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_UsdProfit") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "usdProfit",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.initShareAmount.usdProfit,
                          callback: function($$v) {
                            _vm.$set(_vm.initShareAmount, "usdProfit", $$v)
                          },
                          expression: "initShareAmount.usdProfit"
                        }
                      }),
                      _vm._v(" USD ")
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_NonUsdProfit") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "nonUsdProfit",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.initShareAmount.nonUsdProfit,
                          callback: function($$v) {
                            _vm.$set(_vm.initShareAmount, "nonUsdProfit", $$v)
                          },
                          expression: "initShareAmount.nonUsdProfit"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.localCurrency) + " ")
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_JobProfit") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "jobProfit",
                          disabled: true,
                          precision: 2,
                          controls: false
                        },
                        model: {
                          value: _vm.initShareAmount.jobProfit,
                          callback: function($$v) {
                            _vm.$set(_vm.initShareAmount, "jobProfit", $$v)
                          },
                          expression: "initShareAmount.jobProfit"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.localCurrency) + " ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "el-form-item-wrapper",
                  staticStyle: {
                    "padding-top": "5px",
                    "padding-bottom": "10px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ShareMode") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "130px" },
                          attrs: { no: "shareMode" },
                          on: {
                            change: function($event) {
                              return _vm.changeShareAmount()
                            }
                          },
                          model: {
                            value: _vm.initShareAmount.shareMode,
                            callback: function($$v) {
                              _vm.$set(_vm.initShareAmount, "shareMode", $$v)
                            },
                            expression: "initShareAmount.shareMode"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ShareModeJob"),
                              value: "job"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ShareModeCurrency"),
                              value: "currency"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { "min-height": "200px" }
                },
                [
                  _c("cargo-ag-grid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showNonUsdRatioInput,
                        expression: "showNonUsdRatioInput"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    attrs: {
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.shareBranchList,
                      "auto-fit-content": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  }),
                  _c("cargo-ag-grid", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showNonUsdRatioInput,
                        expression: "!showNonUsdRatioInput"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    attrs: {
                      "grid-options": _vm.gridOptionsJob,
                      "column-defs": _vm.columnDefsJob,
                      "row-data": _vm.shareBranchList,
                      "auto-fit-content": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApiJob = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { float: "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "confirm" },
              on: { click: _vm.onConfirm }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "cancel" }, on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }